import { isDarkPalette } from "@qn/ui";
import { Languages, Moon, Sun } from "lucide-react";
import { useT } from "../lib/i18n";
import { usePrefs } from "../lib/prefs";

const btn =
  "grid size-8 place-items-center rounded-lg text-[var(--fg-muted)] transition hover:bg-[var(--surface-3)] hover:text-[var(--fg)]";

/** Language and light/dark switches as small icon buttons (used on the sign-in screen and in the sidebar). */
export function QuickToggles() {
  const t = useT();
  const { locale, theme, set } = usePrefs();
  const dark =
    theme === "system" ? matchMedia("(prefers-color-scheme: dark)").matches : isDarkPalette(theme);
  return (
    <div className="flex items-center gap-0.5">
      <button
        type="button"
        className={btn}
        title={locale === "ar" ? "English" : "العربية"}
        aria-label={t("toggle.language")}
        onClick={() => set({ locale: locale === "ar" ? "en" : "ar" })}
      >
        <Languages className="size-4" />
      </button>
      <button
        type="button"
        className={btn}
        title={dark ? t("toggle.light") : t("toggle.dark")}
        aria-label={dark ? t("toggle.light") : t("toggle.dark")}
        onClick={() => set({ theme: dark ? "light" : "dark" })}
      >
        {dark ? <Sun className="size-4" /> : <Moon className="size-4" />}
      </button>
    </div>
  );
}
